'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Container } from './elements';
export const ButtonGroup = /*#__PURE__*/React.forwardRef(({
  children,
  alignment = 'start',
  ...rest
}, fRef) => /*#__PURE__*/React.createElement(Container, _extends({
  "data-aui": "button-group",
  ref: fRef,
  alignment: alignment
}, rest), children));